import type { Puzzle } from '../../types';

interface PuzzlesFile {
  source: string;
  license: string;
  generatedAt: string;
  puzzles: [string, string, string, number, string][];
}

let cache: Puzzle[] | null = null;
let inFlight: Promise<Puzzle[]> | null = null;

/**
 * Charge la banque de puzzles hors-ligne (`public/puzzles/lichess-v1.json`,
 * générée par `scripts/build-puzzles.mjs`, servie comme fichier statique —
 * aucune requête vers Lichess au runtime). Mise en cache mémoire : un seul
 * fetch pour toute la durée de vie de l'onglet.
 */
export async function loadPuzzles(): Promise<Puzzle[]> {
  if (cache) return cache;
  if (inFlight) return inFlight;
  inFlight = (async () => {
    const res = await fetch('/puzzles/lichess-v1.json');
    if (!res.ok) throw new Error(`Impossible de charger la banque de puzzles (HTTP ${res.status}).`);
    const data = (await res.json()) as PuzzlesFile;
    if (!Array.isArray(data.puzzles)) throw new Error('Format de banque de puzzles inattendu.');
    const puzzles: Puzzle[] = data.puzzles.map(([id, fen, moves, rating, themes]) => ({
      id,
      fen,
      moves: moves.split(' ').filter(Boolean),
      rating,
      themes: themes.split(' ').filter(Boolean),
    }));
    cache = puzzles;
    return puzzles;
  })();
  try {
    return await inFlight;
  } finally {
    inFlight = null;
  }
}

/** Réservé aux tests : vide le cache mémoire entre deux tests. */
export function resetPuzzleCacheForTests(): void {
  cache = null;
  inFlight = null;
}
